import ApiService from "service/Api";

const OcrActivityService = {
    getOcrActivities: async (page: number, search: string, limit: number) => {
      const requestData = {
        method: "get",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        params: {
          search: search,
          page: page,
          per_page: limit,
        },
        url: "admin/ocr-activities",
      };
  
      try {
        const res = await ApiService.apiRequest(requestData);
        const data = res.data.data;
  
        return data;
      } catch (error) {
        throw error;
      }
    },
  };
  
  export default OcrActivityService;